import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import PrivateRoute from '@/components/PrivateRoute';
import { useIsAdmin } from '@/hooks/useIsAdmin';

type AdminRouteProps = {
  children: React.ReactNode;
};

export default function AdminRoute({ children }: AdminRouteProps) {
  const location = useLocation();
  const { isAdmin, loading } = useIsAdmin();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!loading) setReady(true);
  }, [loading]);

  if (!ready) {
    return (
      <PrivateRoute>
        <div className="flex min-h-[40vh] items-center justify-center text-white/50 font-sans">
          Checking admin access…
        </div>
      </PrivateRoute>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/home" replace state={{ from: location.pathname }} />;
  }

  return <PrivateRoute>{children}</PrivateRoute>;
}
